// extracted by css-extract-rspack-plugin
export default {"cls1":"TopSection-cls1_UCQ","cls2":"TopSection-cls2_5uj TopSection-cls1_UCQ"};